import { ErrorBoundary } from 'react-error-boundary';
import CustomerLookup from 'Feature/Customers/CustomerLookup';
import PolicyLookup from 'Feature/Customers/PolicyLookup';
import ClaimsEmailLink from 'Feature/MyWork/ClaimsEmailLink';
import MyWork from 'Feature/MyWork/MyWork';
import Settings from 'Feature/MyWork/Settings';
import { UserData } from 'Foundation/User/UserContext';
import StandardPage from 'Project/StandardPage';
import { BrowserRouter, Routes, Route } from 'react-router';
import BLLoginError from 'Project/BLLoginError';
import PLLoginError from 'Project/PLLoginError';
import { useEffect } from 'react';
import { useAnalytics } from 'Utilities/Analytics/Analytics';
import { Subapp } from './SubApp';
import Logout from 'Project/Logout';

export const AppRoutes = () => {
  useEffect(() => {
    /* scroll to element id that matches hash from url
     we can remove this once we implement jss and/or no longer pass html to routes the way we are */
    let hash: string = window.location.hash;
    if (hash) document.getElementById(hash.substring(1))?.scrollIntoView();
  }, []);

  try {
    useAnalytics();
  } catch (err: any) {
    console.error(`${'ERROR in AppRoutes: Error in useAnalytics()'}() >> ${err.message}`);
  }
  return (
    <>
      <Subapp />
      <BrowserRouter>
        <ErrorBoundary fallback={<div style={{ display: 'none' }}>{`ERROR in: Routes`}</div>}>
          <Routes>
            <Route path="admin/pl/logout" element={<Logout />} />
            <Route path="admin/bl/logout" element={<Logout />} />
            <Route element={<StandardPage />}>
              <Route path="mywork/mywork" element={<MyWork />} />
              <Route path="*" />
            </Route>
            <Route path="search/policy-lookup" element={<PolicyLookup includeRelatedPolicies={false} />} />
            <Route path="search/customer-lookup" element={<CustomerLookup />} />
            <Route path="mywork/settings" element={<Settings />} />
            <Route path="mywork/claimsemaillink" element={<ClaimsEmailLink />} />
            <Route path="BL/login-error" element={<BLLoginError />} />
            <Route path="PL/login-error" element={<PLLoginError />} />
          </Routes>
        </ErrorBoundary>
        <ErrorBoundary fallback={<div style={{ display: 'none' }}>{`ERROR in: UserData`}</div>}>
          <UserData id="hiddenAppTsx" hidden={true} />
        </ErrorBoundary>
      </BrowserRouter>
    </>
  );
};
